import DataTable from "../Reusable/DataTable/FleetDataTable";
import NACell from "../Reusable/DataTable/NACell";
import APIS from "../../constant/EndPoint";
import TableActionButton from "../Reusable/TableActionButton";
import SwitchButton from "../Reusable/SwitchButton";
import AccessControl from "../../helpers/acessControl";

const RiderList = (props:any) => {
  const { handleIsActive } = props
  const defaultColumns: any = [
    {
      header: "Full Name",
      accessorKey: "user.full_name",
      cell: NACell,
    },
    {
      header: "Mobile Number",
      accessorKey: "user.mobile_number",
      cell: NACell,
    },
    {
      header: "Email",
      accessorKey: "user.email",
      cell: NACell,
    },
    {
      header: "License Number",
      accessorKey: "license_number",
      cell: NACell,
    },

    {
      header: "Citizenship",
      accessorKey: "citizen_ship_number",
      cell: NACell,
    },

    {
      header: "Active",
      accessorKey: "user.is_active",
      cell: ({ row, getValue }) => (
        <AccessControl children={<SwitchButton
          id={row?.original?.user.id}
          value={getValue()}
          disabled={false}
          onChange={handleIsActive}
        />}
          allowedPermissions={["can_update_user"]}
          renderNoAccess={<SwitchButton
            id={row?.original?.user.id}
            value={getValue()}
            disabled={true}
            onChange={handleIsActive}
          />}
        />
      )
    },
  
    {
      header: "Action",
      accessorKey: "id",
      cell: ({ row, getValue }:any) => (
        <>
          <TableActionButton editPath={`edit/${getValue()}`} />
        </>
      ),
    },
  ];

  return (
    <>
      <DataTable
        url={APIS.DRIVER}
        queryKey={"driver"}
        columns={defaultColumns}
        addNewPagePath={"create"}
        tableName={"Rider/Driver"}
      />
    </>
  );
};

export default RiderList;
